<div class="nav-bar-title">
    <div>
        <img src="../../../../assets/icons/new-icons/arrow-back.svg"/>
    </div>
    <div>
        <h3>{{title}}</h3>
    </div>
</div>
